import { render, staticRenderFns } from "./CoIconProcessHouse.vue?vue&type=template&id=bcfacbd6&scoped=true&"
import script from "./CoIconProcessHouse.vue?vue&type=script&lang=ts&"
export * from "./CoIconProcessHouse.vue?vue&type=script&lang=ts&"
import style0 from "./CoIconProcessHouse.vue?vue&type=style&index=0&id=bcfacbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfacbd6",
  null
  
)

export default component.exports